import React, { FC, ReactNode } from "react";
import { Alert } from "antd";
import { useTpaPortalConfig } from "../../../hooks/useTpaPortalConfig";
import PortalWebView from "./PortalWebView";
import "./PortalWebView.css";

type TpaPortalStageLayoutProps = {
  visitStageName?: string | null;
  children: ReactNode;
};

/**
 * Stage form/details first, then Open portal window — matches Mid Office
 * Preauth / Claim flow where portal launch sits after section details.
 */
const TpaPortalStageLayout: FC<TpaPortalStageLayoutProps> = ({
  visitStageName,
  children,
}) => {
  const { config, loading } = useTpaPortalConfig({
    visitStageName,
    enabled: true,
  });

  return (
    <div className="tpa-portal-stage-layout">
      <div className="tpa-portal-form-slot">{children}</div>

      <div className="tpa-portal-after-details">
        <div className="tpa-portal-stage-header">
          <div className="tpa-portal-stage-title">
            {config
              ? `Open portal — ${config.schemeName || config.portalName}`
              : formatHeaderFallback(visitStageName)}
          </div>
          {config?.usedFallbackUrl && (
            <span className="tpa-portal-warning-tag">
              Fallback URL — configure LOGIN URL
            </span>
          )}
        </div>

        {loading ? (
          <PortalWebView config={null} loading />
        ) : config ? (
          <PortalWebView config={config} />
        ) : (
          <Alert
            type="info"
            showIcon
            message="No portal URL configured"
            description="Add a portal URL under Insurance Setup (or Hospital → Credentials) for this scheme."
            style={{ marginBottom: 8 }}
          />
        )}
      </div>
    </div>
  );
};

function formatHeaderFallback(visitStageName?: string | null): string {
  const name = (visitStageName || "").toUpperCase();
  if (name === "PREAUTH") return "Open portal window — Preauth";
  if (name === "CLAIM") return "Open portal window — Claim";
  return name ? `Open portal window — ${name}` : "Open portal window";
}

export default TpaPortalStageLayout;
